import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class Department  {
    _originalTypeClassName = "zERP.BO.Department";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Department.translate = translateService;
}
this.Children = [];
this.Company = new Domain.BusinessEntity();
this.Replacements = [];
this.DepPosition = [];
this.Id = null;
this.Name = null;
this.Level = null;
this.FullName = null;
this.IsActive = false;
this.AvailablePositions = null;
this.OpenPositions = null;
this.OccupiedPositions = null;
this.Code_ = null;
this.SumOpenPositions = null;
this.SumOccupiedPositions = null;
this.SumAvailablePositions = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
Level:any;
FullName:any;
IsActive:any;
AvailablePositions:any;
OpenPositions:any;
OccupiedPositions:any;
Code_:any;
SumOpenPositions:any;
SumOccupiedPositions:any;
SumAvailablePositions:any;
Parent:any;
Children:any;
ContactDetails:any;
Company:any;
DepartmentCategory:any;
Employee:any;
Supervisor:any;
Replacements:any;
ReplacementSupervisor:any;
DepPosition:any;
CostCenter:any;
static setParent = ($this, value) => {
var oldValue = $this.Parent;
$this.Parent = value;
if (value != null) {
if (oldValue != null) {
Domain.Department.removeChildren(oldValue, $this);
}
Domain.Department.addChildren(value, $this);
}
}
static setChildren = ($this, items) => {
                if (items == null) items = [];
                if ($this.Children == null) $this.Children = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Children.length > 0) {
                    Domain.Department.removeChildren($this, $this.Children[0]);
                }

                Domain.Department.addManyChildren($this, copyItems);
            }
static addManyChildren = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Department.addChildren($this, items[i]);
                }
            }
static addChildren = ($this, item) => {
                if ($this.Children == null) $this.Children = [];
                if (item == null || $this.Children.indexOf(item) > -1) return;
                $this.Children.push(item);
if (item.Parent != $this) {
Domain.Department.setParent(item, $this);
}
}
static addRangeChildren = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Department.addChildren($this, item));
            }
static removeChildren = ($this, item) => {
                if ($this == null || $this.Children == null || $this.Children.indexOf(item) === -1) return;
                var _index = $this.Children.indexOf(item);
                $this.Children.splice(_index, 1);
item.Parent = null;
}
static clearChildren = ($this) => { $this.Children = null; }
static setContactDetails = ($this, value) => {
var oldValue = $this.ContactDetails;
$this.ContactDetails = value;
if (value != null) {
}
}
static setCompany = ($this, value) => {
var oldValue = $this.Company;
$this.Company = value;
if (value != null) {
if (oldValue != null) {
Domain.BusinessEntity.removeDepartments(oldValue, $this);
}
Domain.BusinessEntity.addDepartments(value, $this);
}
}
static setDepartmentCategory = ($this, value) => {
var oldValue = $this.DepartmentCategory;
$this.DepartmentCategory = value;
if (value != null) {
}
}
static setEmployee = ($this, value) => {
var oldValue = $this.Employee;
$this.Employee = value;
if (value != null) {
}
}
static setSupervisor = ($this, value) => {
var oldValue = $this.Supervisor;
$this.Supervisor = value;
if (value != null) {
}
}
static setReplacements = ($this, items) => {
                if (items == null) items = [];
                if ($this.Replacements == null) $this.Replacements = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Replacements.length > 0) {
                    Domain.Department.removeReplacements($this, $this.Replacements[0]);
                }

                Domain.Department.addManyReplacements($this, copyItems);
            }
static addManyReplacements = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Department.addReplacements($this, items[i]);
                }
            }
static addReplacements = ($this, item) => {
                if ($this.Replacements == null) $this.Replacements = [];
                if (item == null || $this.Replacements.indexOf(item) > -1) return;
                $this.Replacements.push(item);
}
static addRangeReplacements = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Department.addReplacements($this, item));
            }
static removeReplacements = ($this, item) => {
                if ($this == null || $this.Replacements == null || $this.Replacements.indexOf(item) === -1) return;
                var _index = $this.Replacements.indexOf(item);
                $this.Replacements.splice(_index, 1);
}
static clearReplacements = ($this) => { $this.Replacements = null; }
static setReplacementSupervisor = ($this, value) => {
var oldValue = $this.ReplacementSupervisor;
$this.ReplacementSupervisor = value;
if (value != null) {
}
}
static setDepPosition = ($this, items) => {
                if (items == null) items = [];
                if ($this.DepPosition == null) $this.DepPosition = [];

                const copyItems = Common.cloneObject(items);

                while ($this.DepPosition.length > 0) {
                    Domain.Department.removeDepPosition($this, $this.DepPosition[0]);
                }

                Domain.Department.addManyDepPosition($this, copyItems);
            }
static addManyDepPosition = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Department.addDepPosition($this, items[i]);
                }
            }
static addDepPosition = ($this, item) => {
                if ($this.DepPosition == null) $this.DepPosition = [];
                if (item == null || $this.DepPosition.indexOf(item) > -1) return;
                $this.DepPosition.push(item);
if (item.Department != $this) {
Domain.DepPosition.setDepartment(item, $this);
}
}
static addRangeDepPosition = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Department.addDepPosition($this, item));
            }
static removeDepPosition = ($this, item) => {
                if ($this == null || $this.DepPosition == null || $this.DepPosition.indexOf(item) === -1) return;
                var _index = $this.DepPosition.indexOf(item);
                $this.DepPosition.splice(_index, 1);
item.Department = null;
}
static clearDepPosition = ($this) => { $this.DepPosition = null; }
static setCostCenter = ($this, value) => {
var oldValue = $this.CostCenter;
$this.CostCenter = value;
if (value != null) {
}
}

static CircularParentChildDependencyExists($this: any, departmentToCheck: any): any{for (let _ichild = 0; _ichild < ($this?.Children == null ? 0 : $this?.Children.length); _ichild++) {let child = $this?.Children[_ichild];if (child == departmentToCheck) {return true;}let hasCircularReference = Domain.Department.CircularParentChildDependencyExists(child, departmentToCheck);if (hasCircularReference) {return true;}}
return false;
}
static GetAllDirection(parent: any,allDepartments: any): any{let res = [];
let children = allDepartments?.linq?.where((d) => d?.Parent == parent)?.toArray();
for (let _ichild = 0; _ichild < (children == null ? 0 : children.length); _ichild++) {let child = children[_ichild];res?.add(child);let subchild = Domain.Department.GetAllDirection(child, allDepartments);for (let _isub = 0; _isub < (subchild == null ? 0 : subchild.length); _isub++) {let sub = subchild[_isub];res?.add(sub);}}
return res;
}
static GetClassName(): any{return "Department";
}
static getCostCenterEmployee(cc: any): any{return cc;
}
static GetDepartmentAndAllChildren(parent: any,allDepartments: any): any{let res = [];
let children = allDepartments?.linq?.where((d) => d?.Parent == parent)?.toArray();
for (let _ichild = 0; _ichild < (children == null ? 0 : children.length); _ichild++) {let child = children[_ichild];res?.add(child);let subchild = Domain.Department.GetDepartmentAndAllChildren(child, allDepartments);for (let _isub = 0; _isub < (subchild == null ? 0 : subchild.length); _isub++) {let sub = subchild[_isub];res?.add(sub);}}
return res;
}
static GetFullName($this: any): any{return Joove.Common.safeNumber($this?.Level) + " " + $this?.Name;
}
static GetResponsibleEmployee($this: any, systemModule: any): any{return $this?.Supervisor;
}
static ParseIsActive(el: any): any{return (el == "ΝΑΙ" ? true : false);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}